import { LinkProps } from "react-router-dom";
import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { RouterLink } from "@remo-co/ui-core/src/components/RouterLink";
import useAuthNavigation from "./hooks/useAuthNavigation";

export interface INavigateToSignInProps {
  variant?: "back";
}

const LogInNow = (props: LinkProps) => {
  const { t } = useI18n(["auth"]);

  return (
    <RouterLink {...props} noUnderline>
      <Typography component="span" color="textPrimary">
        {t("auth:back.log.in")}
      </Typography>
    </RouterLink>
  );
};

const NavigateToSignIn = (props: INavigateToSignInProps) => {
  const { variant } = props;
  const { t } = useI18n(["auth"]);
  const url = useAuthNavigation("signin");

  if (variant === "back") {
    return (
      <Typography color="textSecondary" component="span">
        <LogInNow to={url} />
      </Typography>
    );
  }

  return (
    <Typography color="textSecondary" component="span">
      {t("auth:account.exist.already")} <LogInNow to={url} />
    </Typography>
  );
};

export default NavigateToSignIn;
